var _g, _path, _mask, _g2, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardPlatinum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 77.223 105.59",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-44.897,-14.537)",
    fill: "#272727"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m106.86 119.92v-10.407h2.344v1.769h0.122c0.217-0.597 0.576-1.062 1.077-1.396 0.501-0.339 1.1-0.508 1.796-0.508 0.704 0 1.298 0.172 1.781 0.515 0.488 0.339 0.831 0.802 1.03 1.389h0.109c0.23-0.578 0.618-1.039 1.165-1.382 0.551-0.348 1.204-0.522 1.958-0.522 0.957 0 1.739 0.303 2.344 0.908s0.908 1.488 0.908 2.649v6.985h-2.46v-6.606c0-0.646-0.171-1.118-0.514-1.416-0.344-0.302-0.764-0.454-1.261-0.454-0.591 0-1.054 0.185-1.388 0.556-0.33 0.366-0.495 0.842-0.495 1.429v6.491h-2.405v-6.707c0-0.538-0.163-0.967-0.488-1.288-0.321-0.32-0.741-0.481-1.26-0.481-0.352 0-0.673 0.091-0.962 0.271-0.289 0.176-0.52 0.427-0.691 0.752-0.172 0.321-0.258 0.696-0.258 1.125v6.328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.23 115.54v-6.029h2.452v10.406h-2.378v-1.85h-0.108c-0.235 0.583-0.621 1.06-1.159 1.43-0.533 0.37-1.19 0.556-1.9714 0.556-0.682 0-1.285-0.152-1.8089-0.454-0.5195-0.308-0.926-0.752-1.2196-1.335-0.2935-0.587-0.4403-1.296-0.4403-2.127v-6.626h2.4525v6.246c0 0.66 0.1807 1.184 0.542 1.572 0.3614 0.388 0.8356 0.583 1.4227 0.583 0.361 0 0.711-0.088 1.05-0.265 0.339-0.176 0.617-0.438 0.834-0.785 0.221-0.353 0.332-0.793 0.332-1.322z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.757 113.82v6.098h-2.4525v-10.407h2.3441v1.769h0.122c0.2394-0.583 0.621-1.046 1.145-1.389 0.5284-0.343 1.1811-0.515 1.9579-0.515 0.7182 0 1.3438 0.153 1.8767 0.461 0.5375 0.307 0.9531 0.752 1.2466 1.334 0.2981 0.583 0.4449 1.29 0.4404 2.121v6.626h-2.4525v-6.247c0-0.695-0.1807-1.24-0.5421-1.633-0.3568-0.392-0.8513-0.589-1.4837-0.589-0.4291 0-0.8107 0.095-1.145 0.285-0.3297 0.185-0.5894 0.454-0.7791 0.806-0.1852 0.352-0.2778 0.779-0.2778 1.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.668 119.92v-10.406h2.4526v10.406zm1.2331-11.883c-0.3885 0-0.7227-0.129-1.0027-0.387-0.2801-0.262-0.4201-0.575-0.4201-0.941 0-0.371 0.14-0.685 0.4201-0.942 0.28-0.262 0.6142-0.393 1.0027-0.393 0.3929 0 0.7272 0.131 1.0027 0.393 0.28 0.257 0.42 0.571 0.42 0.942 0 0.366-0.14 0.679-0.42 0.941-0.2755 0.258-0.6098 0.387-1.0027 0.387z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.954 109.52v1.897h-5.9823v-1.897zm-4.5054-2.494h2.4526v9.77c0 0.33 0.0497 0.583 0.149 0.759 0.1039 0.171 0.2394 0.289 0.4065 0.352 0.1672 0.063 0.3523 0.095 0.5556 0.095 0.1536 0 0.2936-0.011 0.42-0.034 0.131-0.022 0.2304-0.043 0.2981-0.061l0.4133 1.917c-0.131 0.046-0.3184 0.095-0.5623 0.15-0.2394 0.054-0.533 0.085-0.8808 0.094-0.6142 0.018-1.1675-0.074-1.6598-0.277-0.4924-0.208-0.883-0.529-1.1721-0.962-0.2846-0.434-0.4246-0.976-0.4201-1.626z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.135 120.13c-0.6594 0-1.2534-0.118-1.7818-0.352-0.524-0.24-0.9395-0.592-1.2466-1.057-0.3026-0.466-0.454-1.039-0.454-1.721 0-0.587 0.1084-1.073 0.3252-1.457s0.5127-0.691 0.8876-0.921c0.3749-0.231 0.7972-0.404 1.2669-0.522 0.4742-0.122 0.9643-0.21 1.4702-0.264 0.6097-0.063 1.1043-0.12 1.4837-0.17 0.3794-0.054 0.6549-0.135 0.8266-0.243 0.1761-0.113 0.2642-0.287 0.2642-0.522v-0.041c0-0.51-0.1513-0.905-0.4539-1.185-0.3027-0.28-0.7385-0.42-1.3076-0.42-0.6007 0-1.0772 0.131-1.4295 0.393-0.3478 0.262-0.5827 0.571-0.7047 0.928l-2.2899-0.325c0.1807-0.633 0.4788-1.161 0.8943-1.586 0.4155-0.429 0.9237-0.75 1.5244-0.962 0.6007-0.217 1.2646-0.325 1.9918-0.325 0.5014 0 1.0005 0.059 1.4973 0.176s0.9508 0.312 1.3618 0.583c0.411 0.266 0.7407 0.63 0.9891 1.09 0.253 0.461 0.3794 1.037 0.3794 1.728v6.965h-2.3577v-1.43h-0.0813c-0.149 0.289-0.359 0.56-0.63 0.813-0.2665 0.249-0.603 0.45-1.0095 0.603-0.402 0.149-0.874 0.224-1.416 0.224zm0.6369-1.802c0.4923 0 0.9191-0.097 1.2804-0.292 0.3614-0.198 0.6391-0.46 0.8334-0.786 0.1987-0.325 0.2981-0.679 0.2981-1.063v-1.226c-0.0768 0.063-0.2078 0.121-0.393 0.176-0.1807 0.054-0.3839 0.101-0.6097 0.142-0.2259 0.041-0.4495 0.077-0.6708 0.108-0.2213 0.032-0.4132 0.059-0.5758 0.082-0.3659 0.049-0.6934 0.131-0.9824 0.244-0.2891 0.112-0.5172 0.271-0.6843 0.474-0.1671 0.199-0.2507 0.456-0.2507 0.772 0 0.452 0.1649 0.793 0.4946 1.023 0.3297 0.231 0.7498 0.346 1.2602 0.346z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.956 106.05v13.875h-2.4526v-13.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.671 119.92v-13.875h5.2032c1.066 0 1.9603 0.199 2.6829 0.596 0.7272 0.398 1.276 0.944 1.6464 1.64 0.3748 0.691 0.5623 1.477 0.5623 2.357 0 0.89-0.1875 1.681-0.5623 2.372-0.3749 0.691-0.9282 1.235-1.6599 1.632-0.7317 0.393-1.6328 0.59-2.7033 0.59h-3.4484v-2.067h3.1097c0.6233 0 1.1337-0.108 1.5311-0.325 0.3975-0.217 0.6911-0.515 0.8808-0.894 0.1942-0.379 0.2913-0.815 0.2913-1.308 0-0.492-0.0971-0.926-0.2913-1.3-0.1897-0.375-0.4856-0.667-0.8875-0.874-0.3975-0.213-0.9101-0.319-1.538-0.319h-2.3035v11.775z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m77.223 38.611c0 21.324-17.287 38.611-38.612 38.611-21.324 0-38.611-17.287-38.611-38.611s17.287-38.611 38.611-38.611 38.612 17.287 38.612 38.611z",
    fill: "url(#paint0_linear_1699_3752)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1699_3752",
    x: 57,
    y: 28,
    width: 56,
    height: 56,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m112.16 55.694c0 15.106-12.246 27.352-27.352 27.352s-27.352-12.246-27.352-27.352 12.246-27.352 27.352-27.352 27.352 12.246 27.352 27.352z",
    fill: "#c28b37"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-44.897,-14.537)",
    mask: "url(#mask0_1699_3752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m110.7 52.778c0 15.106-12.246 27.352-27.352 27.352s-27.352-12.246-27.352-27.352 12.246-27.352 27.352-27.352 27.352 12.246 27.352 27.352z",
    fill: "url(#paint1_linear_1699_3752)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m39.633 18.289 6.4352 12.87 12.871 1.6088-8.8379 9.9102 2.4025 14.222-12.87-6.4352-12.87 6.4352 2.4239-14.222-8.8591-9.9102 12.87-1.6088 6.4352-12.87z",
    fill: "url(#paint2_linear_1699_3752)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m39.633 16.256 7.0303 14.061 14.105 1.7632-9.6986 10.876 2.6277 15.555-14.064-7.0321-14.067 7.0336 2.6515-15.557-9.7223-10.876 14.108-1.7635 7.0304-14.061zm-6.4352 14.902-12.87 1.6088 8.8591 9.9102-2.4239 14.222 12.87-6.4352 12.87 6.4352-2.4025-14.222 8.8381-9.9102-12.871-1.6088-6.4352-12.87-6.4352 12.87z",
    clipRule: "evenodd",
    fill: "#fff",
    fillOpacity: 0.2,
    fillRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1699_3752",
    x1: 83.514,
    x2: 83.514,
    y1: 14.537,
    y2: 91.759,
    gradientTransform: "translate(-44.897,-14.537)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FDFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0CFD3",
    offset: 0.5207
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EA4AA",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1699_3752",
    x1: 83.348,
    x2: 83.348,
    y1: 25.426,
    y2: 80.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C7CD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81989E",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1699_3752",
    x1: 84.53,
    x2: 84.53,
    y1: 45.233,
    y2: 69.794,
    gradientTransform: "translate(-44.897,-14.537)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3DFE3",
    offset: 0.8125
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardPlatinum);
export default __webpack_public_path__ + "static/media/reward-platinum.1a46ce2fbae1da2e03c2d8a162c1ca6b.svg";
export { ForwardRef as ReactComponent };